var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5593 3.21934C29.3408 2.43784 30.4024 2 31.5 2H36.84C37.9375 2 38.9991 2.43784 39.7806 3.21934C40.5621 4.00084 41 5.06246 41 6.16V22.18C41 23.2775 40.5621 24.3392 39.7806 25.1207C38.9991 25.9022 37.9375 26.34 36.84 26.34H28.84C28.0115 26.34 27.34 25.6684 27.34 24.84V6.16C27.34 5.06246 27.7778 4.00084 28.5593 3.21934ZM30.34 23.34H36.84C37.1424 23.34 37.4408 23.2178 37.6593 22.9993C37.8778 22.7808 38 22.4825 38 22.18V6.16C38 5.85754 37.8778 5.55916 37.6593 5.34066C37.4408 5.12216 37.1424 5 36.84 5H31.5C31.1975 5 30.8991 5.12216 30.6806 5.34066C30.4621 5.55916 30.34 5.85754 30.34 6.16V23.34Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 24.84C6 24.0115 6.67157 23.34 7.5 23.34H36.84C37.6684 23.34 38.34 24.0115 38.34 24.84C38.34 26.26 37.9092 27.6748 37.0496 28.847C36.2098 29.9922 35.0372 30.8602 33.6824 31.3203C33.6536 31.33 33.6247 31.3389 33.5956 31.3469C33.435 31.4363 33.2974 31.5645 33.1964 31.7194C33.0768 31.9027 33 32.149 33 32.46V43.5C33 44.3284 32.3284 45 31.5 45H14.16C13.7008 45 13.2668 44.7896 12.9824 44.429C12.6979 44.0685 12.5943 43.5975 12.7012 43.1509L13.7767 38.6561C11.5841 37.325 9.73544 35.4775 8.38366 33.288C6.81461 30.7465 6 27.8128 6 24.84ZM32.9118 28.4079C33.5957 28.1344 34.1913 27.6717 34.6304 27.0729C34.796 26.8471 34.9343 26.6008 35.0435 26.34H9.08507C9.30154 28.2413 9.92858 30.0797 10.9363 31.712C12.2151 33.7832 14.031 35.4705 16.1797 36.5628C16.7981 36.8771 17.1202 37.5744 16.9588 38.249L16.0613 42H30V32.46C30 31.651 30.2032 30.8172 30.6836 30.0806C31.1538 29.3596 31.8435 28.7946 32.6615 28.4799C32.7435 28.4484 32.8272 28.4245 32.9118 28.4079Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.12 6.18005C35.9484 6.18005 36.62 6.85163 36.62 7.68005V12.6601C36.62 13.4885 35.9484 14.1601 35.12 14.1601C34.2916 14.1601 33.62 13.4885 33.62 12.6601V7.68005C33.62 6.85163 34.2916 6.18005 35.12 6.18005Z",
    fill: "#14C7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.39bda86433813a293edfeeeac10d26dc.svg";
export { ForwardRef as ReactComponent };